module.exports = __webpack_public_path__ + "static/media/configames-screenshot.90d33c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configames-screenshot.png
// module id = 32
// module chunks = 0